import React from "react";

const CaseStudiesSidebar = ({ data }) => {
  return (
    <>
      <div className="case-studies-sidebar-sticky">
        <div className="case-studies-details-info">
          <ul>
            <li>
              <div className="icon">
                <i className="bx bx-map"></i>
              </div>
              <span>Location:</span>
              {data?.frontmatter?.location}
            </li>

            <li>
              <div className="icon">
                <i className="bx bx-purchase-tag"></i>
              </div>
              <span>Technologies:</span>
              {data?.frontmatter?.technologies.join(", ")}
            </li>

            <li>
              <div className="icon">
                <i className="bx bx-check"></i>
              </div>
              <span>Completed:</span>
              {data?.frontmatter?.completed}
            </li>

            {data?.frontmatter?.demoLink && (
              <li>
                <div className="icon">
                  <i className="bx bx-globe"></i>
                </div>
                <span>Demo Link:</span>
                <a
                  href={`${data?.frontmatter?.demoLink}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {data?.frontmatter?.shorttitle}
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default CaseStudiesSidebar;
